<p class="ms-300" [ngSwitch]="user?.role">

  <app-admin-dashboard *ngSwitchCase="'admin'"></app-admin-dashboard>
  <app-admin-dashboard *ngSwitchCase="'Admin'"></app-admin-dashboard>

  <app-doctors-dashboard *ngSwitchCase="'doctor'"></app-doctors-dashboard>
  <app-doctors-dashboard *ngSwitchCase="'Doctor'"></app-doctors-dashboard>

  <app-nurse-dashboard *ngSwitchCase="'nurse'"></app-nurse-dashboard>
  <app-nurse-dashboard *ngSwitchCase="'Nurse'"></app-nurse-dashboard>

  <app-lab-dashboard *ngSwitchCase="'labtechnician'"></app-lab-dashboard>
  <app-lab-dashboard *ngSwitchCase="'LabTechnician'"></app-lab-dashboard>

  <app-pharmacy-dashboard *ngSwitchCase="'pharmacist'"></app-pharmacy-dashboard>
  <app-pharmacy-dashboard *ngSwitchCase="'Pharmacy'"></app-pharmacy-dashboard>
  <app-pharmacy-dashboard *ngSwitchCase="'pharmacy'"></app-pharmacy-dashboard>

  <app-receptionist-dashboard *ngSwitchCase="'receptionist'"></app-receptionist-dashboard>
  <app-receptionist-dashboard *ngSwitchCase="'Receptionist'"></app-receptionist-dashboard>
  <app-cashier-dashboard *ngSwitchCase="'cashier'"></app-cashier-dashboard>

  <app-patient-dashboard *ngSwitchCase="'patient'"></app-patient-dashboard>
  <app-patient-dashboard *ngSwitchCase="'Patient'"></app-patient-dashboard>
  <app-serviceprovider-dashboard *ngSwitchCase="'serviceprovider'"></app-serviceprovider-dashboard>
  <app-doctors-dashboard *ngSwitchCase="'consultant'" [isConsultant]="true"></app-doctors-dashboard>
  <app-doctors-dashboard *ngSwitchCase="'Consultant'" [isConsultant]="true"></app-doctors-dashboard>
  
  <app-superadmin-dashboard *ngSwitchCase="'superadmin'"></app-superadmin-dashboard>
  <app-superadmin-dashboard *ngSwitchCase="'SuperAdmin'"></app-superadmin-dashboard>

  <!-- Default fallback -->
  <app-patient-dashboard *ngSwitchDefault></app-patient-dashboard>

</p>
